import { render, staticRenderFns } from "./Belluno.vue?vue&type=template&id=34ecd310&"
import script from "./Belluno.vue?vue&type=script&lang=js&"
export * from "./Belluno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports